/*eslint-disable*/
const state = {
  UUID: "",
  isLogin: false,
  isShowIndexAD: true,
  isHorizontal: false,
  tab_state: 0,
  mine_tab_state: 0,
  test: 0,
  user_info: "",
  bottomHeight: 53,
  helpCenterId: 15,
  responsibilityId: 12,
  ruleId: 13,
  aboutId: 16,
  pokerFullScreen: false,
  loginEffect: true,
  // init接口里面的链接
  linkList: {
    apkUrl: "",
    appJump: "",
    appDownload: "",
    customerUrl: "",
    ipaUrl: "",
    payDomain: "",
    staticDomain: "",
    regPhoneType: "1",
    loginCaptchaId: "", //登录易盾
    regCaptchaId: "", //注册易盾
    agentDomain: "", //代理域名
    cs_Email: "", //邮箱
    cs_mobile: "", //手机号
    cs_qq: "", //客服QQ
    cs_wechat: "", //微信
    cs_agent_qq: "", //代理QQ
    easy_remember_url: "", //域名
  },
  FrontConfigList: {},
  showdownload: true, //显示下载
  hasImSport: true, //im是否维护
  hasEsport: true, //电竞牛是否维护
  showLogin: false, //显示登录弹出框
  showRegister: false, // 注册弹框显示
  jumpLogin: false, //跳转登录弹框
  hasMessage: false, //显示是否有站内信
  inEmailNum: 0, //站内信个数
  jinGameItem: null, //登录前的游戏item
  homeFloatTopShow: true, //首页弹出框
  homeFloatTopShow2: true, //首页弹出框
  homeFloatTopShow3: true, //首页弹出框
  homeFloatTopShow4: true, //首页弹出框
  homeFloatTopShow5: true, //首页弹出框
  homeDiaShow: false, // 万豪下方弹出框
  homefloatshow: true, // 万豪漂浮显现隐藏
  PayFloatTopShow: true, //支付页面弹框
  GuestFloatTopShow: false, //注册成功弹框
  upholdShow: false, //控制是否维护弹窗
  upholdInfo: "", //维护信息
  allgameInfo: [], //所有游戏平台信息
  isApp: false, //是否是app打开的页面
  currentindex: 0, //gameList_index
  // 优惠搜索的选项
  discountSelectionId: -1,
  discountSelectionIndex: 0,
  //距离顶部距离
  scrollTop: 0,
  // venice 奖池
  veniceStartMoney: 668229213.16,
  checkCount: 0, //连续签到天数
  point: 0, // 连续签到天数
  // build03奖池
  pro3StarMoney: 668229213.16,
  errorMsg: "", //code99999时返回的msg

  // 首页导航type 1.真人 2.体育 3.老虎机 4.棋牌 5.捕鱼 6.彩票 7.个人中心 8.优惠
  indexNav: 0,
  liveNav: 1,
  slotsNav: 3,
  sportsNav: 2,
  chessNav: 4,
  lotteryNav: 6,
  fishNav: 5,
  mineNav: 7,
  discountNav: 8,
  nav_list: [
    {
      back1: "",
      navName: "",
    },
  ],
  // 老虎机图片地址
  picLink: "",
  // 老虎机全部平台
  slotPlatform: [],
  // 老虎机收藏
  mySlot: [],
  // 平台编号
  frontType: 2,
  // 老虎机搜索历史
  searchHistory: [],
  //老虎机平台号
  slotPlatformCode: "",

  // 优惠类型（锁定用）
  discountsTypes: [
    [
      {
        value: "",
        name: "全部类型",
      },
      {
        value: "1",
        name: "流水返利",
      },
      {
        value: "2",
        name: "存款优惠",
      },
      // {value: '3',name: '邀请奖励'},
      // {value: '4',name: '签到奖励'},
      // {value: '6',name: '连续存款优惠'},
      {
        value: "A",
        name: "救援金",
      },
      {
        value: "B",
        name: "VIP升级奖励",
      },
      {
        value: "C",
        name: "VIP蝉联奖励",
      },
      {
        value: "5",
        name: "其他优惠",
      },
      {
        value: "7",
        name: "注册优惠",
      },
    ],
  ],

  // 优惠类型
  gameTypes: [
    // {offerTypeName: '所有游戏',id: -1},
    // {offerTypeName: '老虎机',id: 1},
    // {offerTypeName: '真人',id: 2},
    // {offerTypeName: '体育',id: 3},
    // {offerTypeName: '彩票',id: 4},
    // {offerTypeName: '捕鱼王',id: 5},
    // {offerTypeName: '棋牌',id: 6},
    // {offerTypeName: '其他',id: 8},
  ],
  // 所有优惠列表
  allBonusArticle: [],

  jinGameTypes: [
    {
      offerTypeName: "所有",
      id: -1,
    },
    {
      offerTypeName: "老虎机",
      id: 1,
    },
    {
      offerTypeName: "真人",
      id: 2,
    },
    {
      offerTypeName: "体育",
      id: 3,
    },
    {
      offerTypeName: "彩票",
      id: 4,
    },
    {
      offerTypeName: "捕鱼",
      id: 5,
    },
    {
      offerTypeName: "棋牌",
      id: 6,
    },
    {
      offerTypeName: "其他",
      id: 8,
    },
  ],
  //
  latestDepositTypes: [
    {
      offerTypeName: "待确认",
      id: 0,
    },
    {
      offerTypeName: "成功",
      id: 1,
    },
    {
      offerTypeName: "已过期",
      id: 2,
    },
    {
      offerTypeName: "已取消",
      id: 3,
    },
  ],
  // 乐赢游戏类型
  lyGameTypes: [
    {
      offerTypeName: "所有优惠",
      id: -1,
    },
    {
      offerTypeName: "电子优惠",
      id: 1,
    },
    {
      offerTypeName: "真人优惠",
      id: 2,
    },
    {
      offerTypeName: "体育优惠",
      id: 3,
    },
    {
      offerTypeName: "彩票优惠",
      id: 4,
    },
    {
      offerTypeName: "捕鱼优惠",
      id: 5,
    },
    {
      offerTypeName: "棋牌优惠",
      id: 6,
    },
    {
      offerTypeName: "其他优惠",
      id: 8,
    },
  ],
  //365游戏类型
  betGameTypes: [
    {
      offerTypeName: "所有游戏",
      id: -1,
    },
    {
      offerTypeName: "老虎机",
      id: 1,
    },
    {
      offerTypeName: "真人",
      id: 2,
    },
    {
      offerTypeName: "体育",
      id: 3,
    },
    {
      offerTypeName: "彩票",
      id: 4,
    },
    {
      offerTypeName: "捕鱼王",
      id: 5,
    },
    {
      offerTypeName: "棋牌",
      id: 6,
    },
    {
      offerTypeName: "其他",
      id: 8,
    },
  ],

  /**
   * 多彩宝 */
  // 多彩宝游戏类型
  colorGameTypes: [
    {
      offerTypeName: "所有游戏",
      id: -1,
    },
    // {offerTypeName: '老虎机',id: 1},
    {
      offerTypeName: "真人",
      id: 2,
    },
    {
      offerTypeName: "体育",
      id: 3,
    },
    {
      offerTypeName: "彩票",
      id: 4,
    },
    // {offerTypeName: '捕鱼王',id: 5},
    {
      offerTypeName: "棋牌",
      id: 6,
    },
    {
      offerTypeName: "其他",
      id: 8,
    },
  ],
  // 多彩宝客服
  COLOR_SERVICE: "https://www.baidu.com",
  // 金沙客服
  JIN_SERVICE: "https://www.baidu.com",
  JIN_QQ_SERVICE:
    "mqq://im/chat?chat_type=wpa&uin=97999170&version=1&src_type=web",
  //build23
  JIN_SERVICE: "https://www.2741cs.com/?_=1569231284363",
  // Build04
  Four_SERVICE: "https://www.baidu.com",

  //build10
  WEI_QQ_SERVICE:
    "mqq://im/chat?chat_type=wpa&uin=18511867&version=1&src_type=web",
  //build09
  build09_QQ_SERVICE:
    "mqq://im/chat?chat_type=wpa&uin=26687656&version=1&src_type=web",
  // 下载链接
  Download_url: "",
  // 身份证验证开开关
  isNameVerify: true,
  userInfo: {
    userInfo: {
      userAccount: "",
      withdrawPasswordValid: "",

      nameValid: "",
      name: null,

      emailValid: "",
      email: "",

      mobilePhone: "",
      mobileValid: "",

      status: "",
      level: 1,
    },
    msgNumber: 0,
    offerNumberMap: {
      applyingNumber: 0,
      processingNumber: 0,
      receivedNumber: 0,
      waitReceiveNumber: 0,
    },
    assetsInfoMap: {
      AvailBalance: "",
      accountBalance: "",
      gameAccountList: [],
      mainBalance: "",
    },
    serverInfo: {
      payDomain: "",
    },
    vipInfo: {
      vipName: "",
    },
    userCountInfo: {
      totalWithdraw: 0,
      totalBonus: 0,
    },
  },
  // 最新
  langs: {
    // 多语言切换数据
    keys: "", // 选中的语言
    langsOptions: {}, // 语言种类
    database: null, // 所有翻译
  },
  appDownload: true, // 首页app下载
  betlotteryTitle: "", // 投注页面选择选中的标题
  maintain: {
    // 维护信息相关
    show: false,
    info: "",
  },
  gameCollectIds: [], // 游戏收藏id
  loginTime: null, // 登录成功的时候赋值
  refreshAccount: false, // 刷新账户余额是否进行状态
  registerAgentCode: null, // 注册代理code
  pageLoading: false, // 页面加载动画是否开启
  IframeShow: true, //Iframe状态
  ekdepositRoot: {},
  pushList: [],
};
export default state;



// WEBPACK FOOTER //
// ./src/common/store/state.js